$(document).ready(function() {    
	if ($(window).width() < 992) {
		/*
		var fadeOutBar;
		
		function invokeFade() {
		    console.log('invoked')
		    fadeOutBar = setTimeout( 
		    function() {
		         $('.flickity-page-dots').addClass('fadeout');
		    }, 2000);
		}*/

		var mainProductSlider = new FlickityResponsive('#image-sticky', {
			accessibility: false,
			freeScroll: false,
			contain: true,
			dragThreshold: 15,
			friction: 0.45,
			selectedAttraction: 0.05,
			pageDots: true,
			lazyLoad: false,
			prevNextButtons: true,
			cellAlign: 'center',
			groupCells: 1,
			responsiveNavigation: true,
			destroy: true,
			responsive: [{
				breakpoint: 991,
				settings: {
					destroy: false,
					groupCells: 2
				}
			}, {
				breakpoint: 649,
				settings: {
					prevNextButtons: false,
					groupCells: 1
				}
			}]
		});
	}

	setTimeout(function(){
        var dynamicButton = $('.shopify-payment-button__button');
    
    	if (dynamicButton.length && dynamicButton.hasClass('shopify-payment-button__button--branded')) {
    		$('#product-add-to-cart').addClass('flip-colors');
    	}
    }, 500);

	$('#style_with').click();

	Fancybox.bind('[data-fancybox="gallery"]', {
		Thumbs: {
			type: "classic",
			showOnStart: false,
		},
		Toolbar: {
			display: {
				left: ["infobar"],
				middle: ["zoomIn", "zoomOut", "toggle1to1", ],
				right: ["thumbs", "close"],
			},
		},
		on: {
			init: () => {
				$("body").addClass('zoomed-in');
			},
			destroy: () => {
				$("body").removeClass('zoomed-in');
			}
		}
	});

   //size guide
   var sizeGuideCache = '';
    $('.size-guide-open').click(function(){
      $('body').addClass('open-size-guide');
      if (sizeGuideCache != '') {
         $('#size-guide-content').html(sizeGuideCache);
      } 
      else
        getSizeGuide();
    })
    $('.size-guide-close,.size-guide-inner,.size-guide-inner img').click(function(){
      $('body').removeClass('open-size-guide');
    })

    function getSizeGuide() {
      var sgURL = window.baseURL + '/pages/size-guide?view=stripped';
      
      $.ajax({
        type: "get",
        url: sgURL,
        success: function(e) {
          sizeGuideCache = e;
          $('#size-guide-content').html(e);   
        },
        error: function(e) {
          $('#size-guide-content').html(e);
        }
      })
    }
  
    //popup tabby
    $('.tabbyCustom').click(function () {
      var tabbyPromo = document.getElementById('tabbyPromoPage');
      tabbyPromo.src = tabbyPromo.dataset.src;
      $(".notification-box").addClass('popit');
    });
    $('.notification-close,.continueTabby,.notification-box').click(function () {
      $(".notification-box").removeClass('popit');
    });

    //mobile sharing
	if (navigator.share) {
		function shareProductImage() {	
            var content = $('.product-description.short-excerpt').text().trim();
            var image = 'https:' + $('.image-item:first-child a').data('image');
            image.replace('width=1200','width=500');
          
            fetch(image)
            .then(response => {
              var blob = response.blob();
              return blob;
            })
            .then((blob) => {
              var file = [new File([blob], 'featured.jpg', {type: "image/jpeg"})];

              var shareData = {
                  title: document.title,
                  text: content,
                  url: window.location.href,
                  files: file
              };
              
              if (navigator.canShare && navigator.canShare(shareData)) {
                navigator.share(shareData);
              }
            })
            .catch((error) => {
              console.error('Error:', error);
            });
    	}
      
		$(document).on("click touchstart", ".share-icon", function() {
			shareProductImage();
		});
      
    }
    else {
      $('.share-icon').hide();
	}

    setTimeout(function(){   
      if($('.swatch .swatch-element.soldout').hasClass('active')){
        $('#product-add-to-cart').addClass('disable');
      	$('#product-add-to-cart span').text('Sold Out');
      };
      $('#add-to-cart-form #product-variants .swatch .swatch-element.soldout').click(function() {
		$('#product-add-to-cart').addClass('disable');
        $('#product-add-to-cart span').text('Sold Out');
      });
    }, 500);

    $(".available").click(function() {
      $('.swatch-element.active').hasClass('soldout').length;
      var soldState = setInterval(function(){
        if ($('.swatch-element.active').hasClass('soldout')) {
        	$('#product-add-to-cart span').text('Sold Out');
          $('#product-add-to-cart').addClass('disable');
          	clearInterval(soldState);
        } else {
          $('#product-add-to-cart').removeClass('disable');
        	$('#product-add-to-cart span').text(product.button_addtocart);
        }
      }, 500);
      $('#product-add-to-cart').removeClass('disable');
      $('#product-add-to-cart span').text(product.button_addtocart);
    });
  });

  $(window).on( "orientationchange", function( event ) {
    if ($('body').hasClass('template-product')) location.reload();
  });

  if (product.conditions){
    $(".button-check").click(function(){
      $(".checkout-button").toggleClass("disabled");
      $(this).toggleClass("active");
    });  
  }

  /******* move the below here once we split op.js 
  if (window.use_color_swatch) {
    $(".swatch :radio").change(function() {
      var t = $(this).closest(".swatch").attr("data-option-index");
      var n = $(this).val();
      $(this).closest("form").find(".single-option-selector").eq(t).val(n).trigger("change")
    });
    Shopify.optionsMap = {};
    Shopify.updateOptionsInSelector = function(t) {
      switch (t) {
        case 0:
          var n = "root";
          var r = $(".single-option-selector:eq(0)");
          break;
        case 1:
          var n = $(".single-option-selector:eq(0)").val();
          var r = $(".single-option-selector:eq(1)");
          break;
        case 2:
          var n = $(".single-option-selector:eq(0)").val();
          n += " / " + $(".single-option-selector:eq(1)").val();
          var r = $(".single-option-selector:eq(2)")
          }
      var i = r.val();
      r.empty();
      var s = Shopify.optionsMap[n];
      // if (typeof s === 'undefined') return; //fix this in the future for color variants
      for (var o = 0; o < s.length; o++) {
        var u = s[o];
        var a = $("<option></option>").val(u).html(u);
        r.append(a)
      }
     
      $('.swatch[data-option-index="' + t + '"] .swatch-element').each(function() {
        if ($.inArray($(this).attr("data-value"), s) !== -1) {
          $(this).removeClass("soldout").show().find(":radio").removeAttr("disabled", "disabled").removeAttr("checked")
        } else {
          $(this).addClass("soldout").find(":radio").removeAttr("checked").attr("disabled", "disabled")
        }
      });
      if ($.inArray(i, s) !== -1) {
        r.val(i)
      }
      r.trigger("change")
    };
    
    Shopify.linkOptionSelectors = function(mt) {
      for (var n = 0; n < mt.variants.length; n++) {
        var r = mt.variants[n];
        if (r.available) {
          Shopify.optionsMap["root"] = Shopify.optionsMap["root"] || [];
          Shopify.optionsMap["root"].push(r.option1);
          Shopify.optionsMap["root"] = Shopify.uniq(Shopify.optionsMap["root"]);
          if (mt.options.length > 1) {
            var i = r.option1;
            Shopify.optionsMap[i] = Shopify.optionsMap[i] || [];
            Shopify.optionsMap[i].push(r.option2);
            Shopify.optionsMap[i] = Shopify.uniq(Shopify.optionsMap[i])
          }
          if (mt.options.length === 3) {
            var i = r.option1 + " / " + r.option2;
            Shopify.optionsMap[i] = Shopify.optionsMap[i] || [];
            Shopify.optionsMap[i].push(r.option3);
            Shopify.optionsMap[i] = Shopify.uniq(Shopify.optionsMap[i])
          }
        }
      }
      Shopify.updateOptionsInSelector(0);
      if (mt.options.length > 1) Shopify.updateOptionsInSelector(1);
      if (mt.options.length === 3) Shopify.updateOptionsInSelector(2);
      $(".single-option-selector:eq(0)").change(function() {
        Shopify.updateOptionsInSelector(1);
        if (mt.options.length === 3) Shopify.updateOptionsInSelector(2);
        return true
      });
      $(".single-option-selector:eq(1)").change(function() {
        if (mt.options.length === 3) Shopify.updateOptionsInSelector(2);
        return true
      })
    }
  }
  
  */

  var url = "/products/" + product.handle + ".js" ;
  $.getJSON( url , {
    format: "json"
  })
  .done(function( data ) {
  });

  $('#add-to-cart-form #product-variants .swatch .swatch-element').click(function() {  
    $(this).parent().find('.swatch-element').removeClass('active');
    $(this).addClass('active');
  });
    
  if (product.display_subtotal && product.available) {
    //update price when changing quantity
    function updatePricing() {
      //try pattern one before pattern 2
      var regex = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g;
      var unitPriceTextMatch = $('.product .price').text().match(regex);
  
      if (!unitPriceTextMatch) {
        regex = /([0-9]+[.|,][0-9]+)/g;
        unitPriceTextMatch = $('.product .price').text().match(regex);      
      }
  
      if (unitPriceTextMatch) {
        var unitPriceText = unitPriceTextMatch[0];      
        var unitPrice = unitPriceText.replace(/[.|,]/g,'');
        var quantity = parseInt($('#quantity').val());
        var totalPrice = unitPrice * quantity;
        var totalPriceText = Shopify.formatMoney(totalPrice, window.money_format);
        totalPriceText = totalPriceText.match(regex)[0];
        var regInput = new RegExp(unitPriceText, "g");  
        var totalPriceHtml = $('.product .price').html().replace(regInput ,totalPriceText); 
        $('.product .total-price span').html(totalPriceHtml);      
      }
    }
    
    $('#quantity').on('change', updatePricing);
  }
  
  var selectCallback = function(variant, selector) {
    if (variant) {
      $('.variant-sku').text(variant.sku);
    }
    else {
      $('.variant-sku').empty();
    }
    var addToCart = $('#product-add-to-cart'),
        productPrice = $('.product .price'),
        comparePrice = $('.product .compare-price');  

    if (variant) {
      if (variant.available) {
        // We have a valid product variant, so enable the submit button
        addToCart.removeClass('disabled').removeAttr('disabled').val(product.button_addtocart);
        $('#add-to-cart-form .clear_fix').removeClass("button-unva");
      } else {
        // Variant is sold out, disable the submit button
        addToCart.val('Sold Out').addClass('disabled').attr('disabled', 'disabled');
      }

      // Regardless of stock, update the product price
      productPrice.html(Shopify.formatMoney(variant.price, window.money_format));
      
      // Also update and show the product's compare price if necessary
      if ( variant.compare_at_price > variant.price ) {
        productPrice.addClass("on-sale")
        comparePrice.html(Shopify.formatMoney(variant.compare_at_price, window.money_format)).show();
      } else {
        comparePrice.hide();
        productPrice.removeClass("on-sale");
      }

      // BEGIN SWATCHES
      $('.sw-0 .value-variant').append($('.sw-0 .swatch-element.active input').attr('value'));
      $('.sw-0 .swatch-element').click(function(){
        $('.sw-0 .value-variant').empty();
        $('.sw-0 .value-variant').append($(this).attr('data-value'));
      });
      
      $('.sw-1 .value-variant').append($('.sw-1 .swatch-element.active input').attr('value'));
      $('.sw-1 .swatch-element').click(function(){
        $('.sw-1 .value-variant').empty();
        $('.sw-1 .value-variant').append($(this).attr('data-value'));
      });     
      
      var form = $('#' + selector.domIdPrefix).closest('form');
      for (var i=0,length=variant.options.length; i<length; i++) {
        var radioButton = form.find('.swatch[data-option-index="' + i + '"] :radio[value="' + variant.options[i] +'"]');
        if (radioButton.length) {
          radioButton.get(0).checked = true;
        }
      }
      // END SWATCHES
  
      if (product.display_subtotal && product.available) {
        updatePricing();
      }
      
      if (window.show_multiple_currencies) {
        $('div.prices span.money').each(function() {      
        	$(this).attr('data-currency-' + product.lower_currency, $(this).html());
      	});
          
        Currency.convertAll(window.shop_currency, $('.currencies_ul .currency.selected').data('currency'));
      }
      
    } else {
      // The variant doesn't exist. Just a safeguard for errors, but disable the submit button anyway
      addToCart.val('Unavailable').addClass('disabled').attr('disabled', 'disabled');
    }
    //update variant inventory
    if (product.display_availability) {
      if (variant.available) {
        if (variant.inventory_management!=null) {
          $(".product-inventory span").text("in stock");
        } else {
          $(".product-inventory span").text("in stock");
        }
      } else {
        $(".product-inventory span").text("Out of stock");
      }
    }
    if (variant && variant.featured_image) {
      var originalImage = $("#product-featured-image");
      var newImage = variant.featured_image;
      var element = originalImage[0];
  
      function removeExtent(str){
        var arr = str.split("v=");
        if(arr[0])
          return arr[0];
      }
    }
  };

  $(function($) {
    if (product.available && product.variants_size > 1){
      new Shopify.OptionSelectors('product-selectors', {
        product: product.full,
        onVariantSelected: selectCallback,
        enableHistoryState: true
      });
  
      $( '.swatch :radio' ).change( function() {
        var optionIndex = $( this ).closest( '.swatch' ).attr( 'data-option-index' ),
            optionValue = $( this ).val();
        $( this )
        .closest( 'form' )
        .find( '.single-option-selector' )
        .eq( optionIndex )
        .val( optionValue )
        .trigger( 'change');
      });
  
  
      if (product.available && product.options_size > 1) {
        Shopify.linkOptionSelectors(product.full);
      }
    }
    // Add label if only one product option and it isn't 'Title'. Could be 'Size'.
    if (product.options_size == 1 && product.options_first != 'Title') {
      $('.selector-wrapper:eq(0)').prepend('<label>' + product.options_first + '</label>');
    }
    // Hide selectors if we only have 1 variant and its title contains 'Default'.
    if (product.options_size == 1 && !product.options_first.includes('Default')) {
      $('.selector-wrapper').hide();
    }
    // Auto-select first available variant on page load. Otherwise the product looks sold out.
    if (product.available && product.variants_size > 1) {
      for (var i = 0; i <= product.variant_option.length; i++){
        $('.single-option-selector:eq('+i+')').val(product.variant_option[i]).trigger('change');
      }
    }
});
